import { render, staticRenderFns } from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=template&id=2d04f9a8&scoped=true"
import script from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=style&index=0&id=2d04f9a8&prod&lang=css"
import style1 from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=style&index=1&id=2d04f9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04f9a8",
  null
  
)

export default component.exports